import { getEngagementLetter } from "./ActionsRenderer.service";

/**
 * Initiates download of an engagement letter PDF using the provided filename.
 *
 * Fetches the file as a blob and triggers a download by creating a temporary anchor element.
 *
 * @param {Object} params - Parameters object
 * @param {string} params.letterFileName - The filename of the engagement letter to download
 */
export const downloadEngagementLetterClick = async ({
  letterFileName,
}: {
  letterFileName: string;
}) => {
  try {
    const blob = await getEngagementLetter(letterFileName, "engagementletterfiles");
    const href = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = href;
    link.setAttribute('download', 'engagement_letter.pdf');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error) {
    console.error('Error downloading engagement letter:', error);
  }
};

/**
 * Fetches and displays the engagement letter PDF in a modal view.
 *
 * Converts the fetched blob to a temporary URL and updates state to show a preview modal.
 *
 * @param {Object} params - Parameters object
 * @param {string} params.letterFileName - The filename of the engagement letter to view
 * @param {(url: string) => void} params.setPdfFileUrl - Function to update the PDF preview URL
 * @param {(visible: boolean) => void} params.setTemplatePreviewModal - Function to toggle visibility of the preview modal
 */
export const viewClick = async ({
  letterFileName,
  setPdfFileUrl,
  setTemplatePreviewModal,
}: {
  letterFileName: string;
  setPdfFileUrl: (url: string) => void;
  setTemplatePreviewModal: (visible: boolean) => void;
}) => {
  try {
    const blob = await getEngagementLetter(letterFileName, "engagementletterfiles");
    const url = window.URL.createObjectURL(blob);

    setPdfFileUrl(url);
    setTemplatePreviewModal(true);
  } catch (error) {
    console.error('Error viewing engagement letter:', error);
  }
};
